import { Archive, BarChart3, Banknote, Ban, LayoutDashboard, Scale } from "lucide-react";

// تبويبات صفحة الرواتب — الترتيب من اليمين لليسار في العربية يتبع اتجاه الصفحة تلقائياً.
export const payrollTabs = (t, cycleOn) =>
  [
    { key: "dashboard", label: t("payrollTabs.dashboard"), icon: LayoutDashboard },
    cycleOn ? { key: "disburse", label: t("payrollTabs.disburse"), icon: Banknote } : null,
    { key: "reports", label: t("payrollTabs.reports"), icon: BarChart3 },
    { key: "settlements", label: t("settlements.title"), icon: Scale },
    { key: "holds", label: t("holds.tab"), icon: Ban },
    { key: "archive", label: t("payrollTabs.archive"), icon: Archive },
  ].filter(Boolean);
